import React from "react";
import styled from "styled-components";
import { ChevronRight } from "lucide-react";

const SubscriptionProductCard = ({ icon, title, description, onClick }) => {
  return (
    <Card onClick={onClick}>
      <CardLeft>
        <IconWrapper>{icon}</IconWrapper>
        <TextBlock>
          <Title>{title}</Title>
          <Description>{description}</Description>
        </TextBlock>
      </CardLeft>
      <ChevronWrapper>
        <ChevronRight size={18} color="#7F56D9" strokeWidth={2.5} />
      </ChevronWrapper>
    </Card>
  );
};

export default SubscriptionProductCard;

const Card = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #E9EAEB;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(10, 13, 18, 0.06);
  padding: 24px 28px;
  cursor: pointer;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.12s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: #7F56D9;
    border-radius: 14px 0 0 14px;
    opacity: 0;
    transition: opacity 0.18s ease;
  }

  &:hover {
    border-color: #D6BBFB;
    box-shadow: 0 4px 16px rgba(127, 86, 217, 0.12);
    transform: translateY(-1px);
  }

  &:hover::before {
    opacity: 1;
  }
`;

const CardLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1;
`;

const IconWrapper = styled.div`
  width: 56px;
  height: 56px;
  min-width: 56px;
  border-radius: 14px;
  background: #F4EBFF;
  border: 1px solid #E9D7FE;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.18s ease;

  svg {
    width: 22px;
    height: 22px;
    color: #7F56D9;

    path {
      stroke: #7F56D9;
    }
  }

  ${Card}:hover & {
    background: #EDE0FF;
  }
`;

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.h3`
  color: #181D27;
  font-family: "Lato", sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
  margin: 0;
`;

const Description = styled.p`
  color: #667085;
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  margin: 0;
`;

const ChevronWrapper = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #F4EBFF;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.18s ease, transform 0.18s ease;

  ${Card}:hover & {
    background: #E9D7FE;
    transform: translateX(3px);
  }
`;